import { useDispatch } from 'react-redux';
import { resetInspectionTypeData } from '../stores/inspectionTypeData/slice';
import { resetInspectionTop } from '../stores/inspectionTop/slice';
import { resetTypeLabels } from '../stores/TypeLabels/slice';
import { resetImages } from '../stores/ngSampleImages/slice';
import { resetManuals } from '../stores/manual/slice';
import { resetSelectIds } from '../stores/selectIds/slice';
import { resetConfirmedInspection } from '../stores/confirmedInspection/slice';
import { resetReport } from '../stores/report/slice';
import { resetConfirmedQc } from '../stores/confirmedQc/slice';
import { resetAccountInfo } from '../stores/accountsInfo/slice';
import { resetCodeMaster } from '../stores/codeMaster/slice';
import { resetHistoryData } from '../stores/history/slice';
import { resetMarketCode } from '../stores/marketCode/slice';

const useResetStore = () => {
  const dispatch = useDispatch();

  const resetInspectionStore = () => {
    dispatch(resetSelectIds());
    dispatch(resetInspectionTop());
    dispatch(resetTypeLabels());
    dispatch(resetImages());
    dispatch(resetManuals());
    dispatch(resetInspectionTypeData());
    dispatch(resetConfirmedInspection());
    dispatch(resetConfirmedQc());
    dispatch(resetReport());
  };

  const resetManageStore = () => {
    dispatch(resetAccountInfo());
    dispatch(resetCodeMaster());
    dispatch(resetHistoryData());
    dispatch(resetMarketCode());
  };

  return {
    resetInspectionStore,
    resetManageStore,
  };
};

export default useResetStore;
